export const DataDays = [{
    id: 1,
    description: "Lunes",
    value: "1"
},{
    id: 2,
    description: "Martes",
    value: "2"
},{
    id: 3,
    description: "Miercoles",
    value: "3"
},{
    id: 4,
    description: "Jueves",
    value: "4"
},{
    id: 5,
    description: "Viernes",
    value: "5"
},{
    id: 6,
    description: "Sabado",
    value: "6"
},{
    id: 7,
    description: "Domingo",
    value: "0"
}]


export const diasSemana = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];